<template>
    <!-- 直播卡片 -->
    <div
        :class="['liveCardWrap']"
        @click.stop.prevent="handleClickDetailPage"
    >
        <!--  -->
        <div class="liveCardMain">
            <div
                class="liveCardLeft"
                :style="{
                    backgroundImage: 'url(' + info.room_bg_url + ')'
                }"
            >
                <div class="liveCardState">
                    <div class="liveCardStateIcon">
                        <img v-if="info.room_state == '1'" src="https://cdncos.aigupiao.com/assets/app/h5/user_home/liveInfoCard_icon.gif" alt="">
                        <img v-if="info.room_state == '2'" src="https://cdncos.aigupiao.com/assets/app/h5/user_home/liveInfoCard_icon.svg" alt="">
                    </div>
                    <div class="liveCardStateName">{{info.room_state_info}}</div>
                </div>
                <div class="liveCardInfo" v-if="info.room_state == '1'">
                    <div
                        :style="{
                            backgroundImage: 'url(' + info.avatar + ')'
                        }"
                    ></div>
                    <span>{{ info.user_name }}</span>
                </div>
                <div class="liveCardVideo" v-if="info.room_state == '2'">
                    <button></button>
                </div>
            </div>
            <div class="liveCardRight">
                <div class="liveCardTitle">
                    <p>{{info.room_name}}</p>
                </div>
                <div class="liveCardBrief">
                    <p v-if="info.room_state == '1'">{{info.room_duration}}</p>
                    <p v-if="info.room_state == '2'">{{info.room_info}}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "liveCard",
    props: {
        info: {
            type: Object
        },
        userInfo: {
            type: Object
        },
    },
    data() {
        return {
            ending: false,
        }
    },
    created() {
        // // preview_live_time
        // // 判断一下当前的时间
        // let nowDate = new Date().getTime();
        // // 
        // let cardTime = this.info.preview_live_time;
        // if(typeof cardTime == 'string') {
        //     cardTime = cardTime.replace(/-/g, '/')
        // }
        // let cardDate = new Date(cardTime).getTime();

        // if(nowDate > cardDate) {
        //     this.ending = true;
        // } else {
        //     this.ending = false;
        // }
    },
    methods: {
        // 跳转页面
        handleClickDetailPage() {
            // 跳转直播越高
            this.openNative('video_live_page', {
                id: this.info.room_id
            })
        },
        // 跳转APP页面
        openNative(type, query = {}) {
            let params = {
                kind: type, // 类型
            };

            params = {
                ...params,
                ...query
            }

            switch (type) {
                case "video_live_page": // 视频直播间
                    break;
            }

            this.$srH5CallNativeMethodApp('call_Native', params)
        },
    },
    computed: {}
}
</script>
<style scoped lang="scss">
@import "~@/assets/sass/global.scss";
.liveCardWrap {
    padding:rem2(10px) rem2(12px) rem2(12px);
    box-sizing: border-box;

    .liveCardMain {
        width: 100%;
        height: rem2(86px);
        border-radius: rem2(10px);
        overflow: hidden;
        display: flex;
        flex-direction: row;
        background-color: #FFF;

        .liveCardLeft {
            width: rem2(137px);
            height: rem2(86px);
            position: relative;
            background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/liveInfoCard_bg.png");
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            padding: rem2(8px);
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .liveCardState {
                width: max-content;
                height: rem2(19px);
                border-radius: rem2(9.5px);
                background: rgba(0, 0, 0, 0.30);
                display: inline-flex;
                flex-direction: row;
                align-items: center;
                padding-right: rem2(6.5px);
                box-sizing: border-box;

                .liveCardStateIcon {
                    width: rem2(19px);
                    height: rem2(19px);
                    border-radius: 50%;
                    background-color: transparent;
                    background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/liveInfoCard_circle.svg");
                    background-size: 100%;
                    background-repeat: no-repeat;
                    background-position: center;
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                    margin-right: rem2(3.5px);

                    img {
                        width: rem2(10px);
                        height: auto;
                        display: block;
                    }
                }

                .liveCardStateName {
                    color: #FFF;
                    font-size: rem2(10px);
                    font-style: normal;
                    font-weight: 400;
                    line-height: rem2(19px); /* 120% */
                    letter-spacing: rem2(0.3px);
                }
            }

            .liveCardInfo {
                width: auto;
                height: rem2(21px);
                line-height: rem2(21px);
                box-sizing: border-box;
                display: flex;
                flex-direction: row;
                align-items: center;

                & > div {
                    width: rem2(21px);
                    height: rem2(21px);
                    border-radius: 50%;
                    overflow: hidden;
                    background-color: transparent;
                    background-size: rem2(21px) rem2(21px);
                    background-position: left center;
                    background-repeat: no-repeat;
                }

                & > span {
                    color: #FFF;
                    font-size: rem2(12px);
                    font-style: normal;
                    font-weight: 400;
                    margin-left: rem2(4px);
                }
            }

            .liveCardVideo {
                display: flex;
                flex-direction: row-reverse;

                button {
                    width: rem2(27px);
                    height: rem2(27.5px);
                    background-color: transparent;
                    background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/liveInfoVideo.svg");
                    background-size: 100%;
                    background-repeat: no-repeat;
                    background-position: center;
                    border: none;
                    outline: none;
                }
            }
        }

        .liveCardRight {
            flex: 1;
            overflow: hidden;
            padding: rem2(12.5px) rem2(14px) rem2(10px) rem2(14px);
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .liveCardTitle {

                p {
                    color: #333;
                    font-size: rem2(16px);
                    font-style: normal;
                    font-weight: 500;
                    line-height: rem2(18px); /* 112.5% */
                }
            }

            .liveCardBrief {

                p {
                    color: #939393;
                    font-size: rem2(12px);
                    font-style: normal;
                    font-weight: 400;
                    line-height: rem2(16px); /* 133.333% */
                }
            }
        }
    }
}
</style>